import React, { useMemo } from 'react';
import BubbleCommon, {
  keywordConfigNlpTips,
  keywordConfigTips,
} from '../../BubbleCommon';
import { initialUpperCase } from '../utils';
import { useIntl } from 'umi';

const list = [
  {
    value: 'nlp',
    text: 'NLP Generated',
    textTip: keywordConfigNlpTips,
  },
  {
    value: 'config',
    text: 'Configured',
    textTip: keywordConfigTips,
  },
];

export function useKeywordFilterType() {
  const { formatMessage } = useIntl();

  function getItemText(text: string, tips: any) {
    return (
      <>
        <BubbleCommon placement="right" showIcon={false} tipsMap={tips}>
          <div className="dbo-item-text">{initialUpperCase(text)}</div>
        </BubbleCommon>
      </>
    );
  }

  const filterTypeOptions = useMemo(() => {
    const data: {
      value: string;
      text: React.JSX.Element;
      showText: string;
    }[] = [];
    list.forEach((e) => {
      data.push({
        value: e.value,
        text: getItemText(formatMessage({ id: e?.text || '' }), e?.textTip),
        showText: formatMessage({ id: e?.text || '' }),
      });
    });
    return data;
  }, [formatMessage]);

  return {
    getItemText,
    filterTypeOptions,
  };
}
